import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Braintree } from 'react-braintree-fields';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

import { Spinner, Alert, Button } from 'components/Common';
import { PaymentCardFormField } from 'components';

export class PaymentCardForm extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    isUpdating: PropTypes.bool.isRequired,
    authorizationToken: PropTypes.string,
    onSubmit: PropTypes.func.isRequired
  };

  static defaultProps = {
    authorizationToken: null
  };

  constructor(props) {
    super(props);

    this.state = {
      isBraintreeReady: false,
      isGettingToken: false,
      hasError: false
    };
  }

  handleAuthorizationSuccess = () => {
    this.setState({ isBraintreeReady: true });
  };

  handleSubmit = () => {
    this.setState({ isGettingToken: true, hasError: false });

    this.getToken().then(
      payload => {
        this.props.onSubmit(payload.nonce);
        this.setState({ isGettingToken: false });
      },
      error => {
        this.setState({ isGettingToken: false, hasError: true });
      }
    );
  };

  renderAlert() {
    return (
      <Alert
        description={this.props.t('paymentMethod.paymentCard.errors.failed')}
      />
    );
  }

  renderFields() {
    return (
      <div className="row">
        <div className="column small-12">
          <PaymentCardFormField type="number" />
        </div>
        <div className="column small-12 large-4">
          <PaymentCardFormField type="expirationMonth" />
        </div>
        <div className="column small-12 large-4">
          <PaymentCardFormField type="expirationYear" />
        </div>
        <div className="column small-12 large-4">
          <PaymentCardFormField type="cvv" />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {!this.state.isBraintreeReady && <Spinner />}

        <div
          className="row"
          style={{
            visibility: !this.state.isBraintreeReady ? 'hidden' : 'visible'
          }}
        >
          <div className="column small-12 large-8">
            <h2>{this.props.t('paymentMethod.paymentCard.heading')}</h2>

            <p>{this.props.t('paymentMethod.paymentCard.description')}</p>

            <Braintree
              authorization={this.props.authorizationToken}
              onAuthorizationSuccess={this.handleAuthorizationSuccess}
              getTokenRef={ref => (this.getToken = ref)}
              styles={{ input: { 'font-size': '16px' } }}
            >
              {this.state.hasError && this.renderAlert()}

              {this.renderFields()}

              <Button
                marginBottom
                onClick={this.handleSubmit}
                isLoading={this.state.isGettingToken || this.props.isUpdating}
              >
                {this.props.t('paymentMethod.updatePaymentMethod')}
              </Button>
            </Braintree>

            <Link className="link-nav" to="/payment-method">
              &larr; {this.props.t('general.cancel')}
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default translate()(PaymentCardForm);



// WEBPACK FOOTER //
// ./src/components/PaymentCardForm/PaymentCardForm.js